const initialState = () => ({
  id: null,
  name: null,
  protocol: null,
  slashes: null,
  host: null,
  hostname: null,
  port: null,
  href: null
})

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    assign(state, { id, name, protocol, slashes, host, hostname, port, href }) {
      state.id = id
      state.name = name
      state.protocol = protocol
      state.slashes = slashes
      state.host = host
      state.hostname = hostname
      state.port = port
      state.href = href
    }
  }
}
